import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.query.prueflauf-bild';
import * as api from '../../../clients/qschecks';

@Injectable()
export class QschecksPrueflaufBildEffects {

    PrueflaufBild$ = createEffect(() => this.actions$.pipe(
        ofType(ac.GET_PRUEFLAUF_BILD),
        mergeMap((x: ac.GetPrueflaufBildAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().getPrueflaufBild(x.prueflauf_id, x.bild_id, x.width, x.height).pipe(
                map((result: any) => {
                    return new ac.GetPrueflaufBildErfolgreichAction(result, x.prueflauf_id, x.bild_id, x.width, x.height, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.GetPrueflaufBildFehlerAction(error, x.prueflauf_id, x.bild_id, x.width, x.height, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.PrueflaufQueryService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.PrueflaufQueryService {
        if (this.service === null) {
            this.service = this.injector.get(api.PrueflaufQueryService);
        }
        return this.service;
    }
}
